// import { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import apiClient from "../../utils/apiClient";

// export const useOrganizationPlan = (organizationId) => {
//   const [orgPlan, setOrgPlan] = useState(null);
//   const [orgUsage, setOrgUsage] = useState({
//     projects: 0,
//     client_admins: 0,
//     project_admins: 0,
//     surveyors: 0,
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!organizationId) return;

//     const fetchOrgPlan = async () => {
//       setLoading(true);

//       const toastId = toast;

//       try {
//         const response = await apiClient.get(`/subscriptions/${organizationId}/`);
        
//         setOrgPlan(response.data.plan);
//         setOrgUsage(response.data.usage || {
//           projects: 0,
//           client_admins: 0,
//           project_admins: 0,
//           surveyors: 0,
//         });

//         toast.update(toastId, {
//           // render: "Organization plan loaded",
//           type: "success",
//           isLoading: false,
//           autoClose: 1800,
//         });
//       } catch (err) {
//         const errorMessage =
//           err.response?.data?.data ||
//           err.data ||
//           "Failed to fetch organization plan";

//         toast.update(toastId, {
//           render: errorMessage,
//           type: "error",
//           isLoading: false,
//         });

//         setError(errorMessage);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOrgPlan();
//   }, [organizationId]);

//   return { orgPlan, orgUsage, loading, error };
// };
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import apiClient from "../../utils/apiClient";

export const useOrganizationPlan = (organizationId) => {
  const [orgPlan, setOrgPlan] = useState(null);
  const [orgUsage, setOrgUsage] = useState({
    projects: 0,
    client_admins: 0,
    project_admins: 0,
    surveyors: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
 // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to fetch organization plan.",
    };
  };

  useEffect(() => {
    if (!organizationId) return;

    const fetchOrgPlan = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiClient.get(
          `/subscriptions/${organizationId}/`
        );

        setOrgPlan(response.data.plan);
        setOrgUsage(
          response.data.usage || {
            projects: 0,
            client_admins: 0,
            project_admins: 0,
            surveyors: 0,
          }
        );
      } catch (err) {
        const { title, issue } = extractError(err);

        toast.error(
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        );

        setError({ title, issue });
      } finally {
        setLoading(false);
      }
    };

    fetchOrgPlan();
  }, [organizationId]);

  return { orgPlan, orgUsage, loading, error };
};